<template>
    <b-modal title="Session Recordings" size="lg" id="recordingsModal" ok-only>

        <div style="color: red; margin-bottom: 1em;">Recordings are only available to download for 7 days from creation</div>
        <RecordingsList :sessionId="sessionId" />
    </b-modal>
</template>

<script>
import RecordingsList from "./RecordingsList";

export default {
    name: "RecordingsModal",
    props: {
        sessionId: { type: String },
    },
    components: {
        RecordingsList,
    },
};
</script>